/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
export const getProjectContainerScope = (projectId: number | string): string =>
	`project-${projectId}`;

export const getCollectionContainerScope = (collectionUUID: string): string =>
	`collection-${collectionUUID}`;
